module.exports = __webpack_public_path__ + "img/9443d45.webp";